import * as React from 'react';
import { Component } from 'react';
import BasicSearchCriteriaComponent from '../Search/BasicSearchCriteria';
import './Home.css';
import { StaticInfoComponent } from './StaticInfo';
import FooterComponent from '../Layout/Footer';
import FooterStaticComponent from '../Layout/FooterStatic';
import { ISearchSelectedItem } from '../../models/ISearchSelectedItem';
import Helmet from 'react-helmet';
// import { TeleInfoComponent } from './TeleInfo';
import { TELE_PLACE } from '../../constants/TelePlace';
// import Banner from "./Banner";

interface IState {
    ShowStaticInfoComponent: boolean,
    TeleInfoVisible: boolean,
    TeleInfoCollapsed: boolean
}

export class HomeComponent extends Component<any, IState> {

    private basicSearchRef = React.createRef<any>();

    constructor(props) {
        super(props);

        this.state = {
            ShowStaticInfoComponent: false,
            TeleInfoVisible: true,
            TeleInfoCollapsed: window.innerWidth < 768
        }

        this.OnFooterItemClick = this.OnFooterItemClick.bind(this);
        this.OnScroll = this.OnScroll.bind(this);
        this.OnTeleInfoPopupClick = this.OnTeleInfoPopupClick.bind(this);
        this.OnTeleInfoPopupCollapse = this.OnTeleInfoPopupCollapse.bind(this);
    }

    public componentWillMount() {
        document.addEventListener('scroll', this.OnScroll, false);
    }

    public componentWillUnmount() {
        document.removeEventListener('scroll', this.OnScroll, false);
    }

    public componentDidMount () {
        const script = document.createElement("script");
        script.innerHTML=`
        /* (c)AdOcean 2003-2021, kif_admin.Znajd_ Fizjoterapeut_.STRONA G__wna.DBB750x200px */
        ado.placement({id: 'ado-BZs6BPANk_negwhJnt9KpzGIAXLncwdPxuhkUr3U8z7.A7', server: 'gpl.adocean.pl' });
        `;
        const parent = document.getElementById("home-ad-banner-wrapper");
        if (parent !== null) {
            parent.appendChild(script);
        }
    }

    public render() {
        return (
            <div className="home-component route-component">
                <Helmet>
                    <meta name="title" content="Znajdź Fizjoterapeutę - wyszukiwarka fizjoterapeutów w Twojej okolicy" />
                    <meta name="description" content="Znajdź zaufanego fizjoterapeutę i umów wizytę w dogodnym terminie. Najbardziej aktualna baza fizjoterapeutów z prawem wykonywania zawodu." />
                </Helmet>
                <div>
                    <div className="search-wrapper">
                        <div className="home-wrapper">
                            <h1 className="main-title center-text">
                                Szukaj <b>zaufanego fizjoterapeuty</b> i&nbsp;<b>umów wizytę</b> w&nbsp;dogodnym terminie.
                            </h1>
                            <div className="search-main">
                                <BasicSearchCriteriaComponent ref={this.basicSearchRef} />
                            </div>

                            <div id="home-ad-banner-wrapper">
                                {/* Adocean placement start*/}
                                <div className="home-ad-banner" id="ado-BZs6BPANk_negwhJnt9KpzGIAXLncwdPxuhkUr3U8z7.A7" />
                                {/* Adocean placement end*/}
                            </div>

                            {/* <Banner
                                BannerLink="https://sanosil.pl/sklep/"
                                BannerImage="/images/blog/banners/bannerSANOSIL.jpg"
                            /> */}
                        </div>
                    </div>
                    {this.RenderStaticInfoComponent()}
                </div>
                <FooterComponent OnItemClick={this.OnFooterItemClick} />
                <FooterStaticComponent />
                {/* {this.RenderTeleInfo()} */}
            </div>
        );
    }

    private RenderStaticInfoComponent() {
        if (this.state.ShowStaticInfoComponent) {
            return (
                <StaticInfoComponent />
            );
        } else {
            return null;
        }
    }

    // private RenderTeleInfo() {
    //     if (this.state.TeleInfoVisible) {
    //         return (
    //             <TeleInfoComponent
    //                 OnClick={this.OnTeleInfoPopupClick}
    //                 OnToggleCollapse={this.OnTeleInfoPopupCollapse}
    //                 Collapsed={this.state.TeleInfoCollapsed} />
    //         );
    //     } else {
    //         return null;
    //     }
    // }

    private OnFooterItemClick(item: ISearchSelectedItem) {
        window.scrollTo(0, 0);
        if (this.basicSearchRef.current !== null) {
            this.basicSearchRef.current.Search(item);
        }
    }

    private OnScroll(evt) {
        if (this.state.ShowStaticInfoComponent === false) {
            this.setState({
                ShowStaticInfoComponent: true
            });
        }
    }

    private OnTeleInfoPopupClick() {
        window.scrollTo(0, 0);
        if (this.basicSearchRef.current !== null) {
            this.basicSearchRef.current.SearchPlace(TELE_PLACE);
        }
    }

    private OnTeleInfoPopupCollapse() {
        this.setState({
            TeleInfoCollapsed: !this.state.TeleInfoCollapsed
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/Home/Home.tsx